var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreachRiskVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1313.002 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M74.3,33h21.75l-23.7,102H34.1L10.4,33h21.75l17.7,84H56.6Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.222,135V63.6h46.2V76.2H117.711V92.9h25.411v12.389H117.711V122.4h31.711V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.78,111.061V135H159.29V63.6h27.72q25.2,0,25.2,23.519,0,13.966-10.5,20.58L211.9,135H196.04l-8.295-23.939Zm21.1-15.54a12.885,12.885,0,0,0,2.52-8.3,11.964,11.964,0,0,0-2.677-8.191q-2.679-3.043-7.718-3.045H173.78V98.67h13.44Q192.364,98.67,194.885,95.521Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.29,135V63.6h14.489V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.219,135V63.6h45.57V76.2h-31.08v21h25.41v12.6h-25.41V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.873,135V63.6h14.49V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.058,133.846A95.585,95.585,0,0,1,357,136.26q-8.926,0-14.28-2.2a17.609,17.609,0,0,1-8.4-7.035,31.244,31.244,0,0,1-4.2-11.34A96.214,96.214,0,0,1,328.968,99.3q0-20.683,5.827-28.822t21.473-8.138a91.365,91.365,0,0,1,20.9,2.835l-.42,11.551A119.155,119.155,0,0,0,359.47,75.15q-6.878,0-9.817,1.837T345.3,83.971q-1.417,5.144-1.417,17.534t2.887,17.168q2.886,4.778,11.55,4.777a123.936,123.936,0,0,0,18.428-1.47Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.732,135,396.8,63.6h27.51L440.372,135h-14.49l-2.835-12.915h-24.99L395.222,135Zm27.3-59.43-7.245,33.915h19.53L413.072,75.57Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.538,76.41V63.6h52.5V76.41h-18.9V135h-14.49V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.071,135V63.6h14.49V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.4,127.388q-6.668,8.874-22.942,8.872t-22.942-8.872q-6.67-8.871-6.668-27.773t6.668-28.088q6.666-9.186,22.942-9.187T574.4,71.527q6.667,9.191,6.668,28.088T574.4,127.388Zm-34.545-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479t-3.15-18.848q-3.15-5.88-11.55-5.88t-11.55,5.88q-3.15,5.882-3.15,18.848T539.858,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.36,135V63.6h24.465l17.22,58.8h1.05V63.6h14.49V135H624.75L606.9,76.2h-1.05V135Z",
    style: {
      fill: "#5e1513"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreachRiskVerification);
export default __webpack_public_path__ + "static/media/BreachRisk_Verification.3088795ad38e24b9656393f211fb6699.svg";
export { ForwardRef as ReactComponent };